import React, { useState } from "react";
import './style.css'
import Button from "../../Components/ui/button";
import Logo from "../../Images/New/Products/easyAcc.webp"
import h1 from "../../Images/New/Hero/1.gif"
import h2 from "../../Images/New/Hero/2.gif"
import h3 from "../../Images/New/Hero/3.gif"
import h4 from "../../Images/New/Hero/4.gif"
import h5 from "../../Images/New/Hero/5.gif"
import h6 from "../../Images/New/Hero/6.gif"
import h7 from "../../Images/New/Hero/7.gif"
import h8 from "../../Images/New/Hero/8.gif"

const Hero = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleExpand = () => {
    setIsExpanded(!isExpanded);
  };
  return (
    <>
      <div
        className={` ${
          isExpanded ? "items-start" : "items-center"
        } pt-16 pb-7 ${isExpanded ? "h-full" : "h-screen"} flex bg-[#ffffff]`}
      >
        <div
          class={`context ${isExpanded ? 'relative' : 'absolute'} flex justify-center z-40 ${
            isExpanded ? "sm:mt-[100px]" : ""
          }`}
        >
          <div className="h-full sm:flex items-center px-3 w-full max-w-7xl mt-[1000px] sm:mt-0">
            <div className=" sm:w-1/2 pl-3 sm:pl-12">
              {/* <p className="sm:text-3xl text-2xl font-semibold text-black">
                EasyACC
              </p> */}
              <img src={Logo} alt="Logo" className="w-[40%]" />
              <p
                className="sm:text-3xl text-2xl font-extrabold mt-3"
                style={{
                  backgroundImage:
                    "linear-gradient(120deg, #0077b3 0%, #00aacc 100%)",
                  WebkitBackgroundClip: "text",
                  backgroundClip: "text",
                  color: "transparent",
                }}
              >
                Accounting Inventory Invoicing Management Software
              </p>
              <p className="text-2xl font-semibold text-black mt-3">
                Accounting Software for Growing Businesses
              </p>
              <p className="sm:text-lg text-lg font-semibold text-black mt-3">
                EasyACC is a Complete Accounting, Inventory & Invoicing
                Management software. This financial accounting software is
                widely used by small and medium businesses, traders, retailers,
                dealers, distributors and manufacturing units.With its
                user-friendly advanced features, EasyACC Software is an ideal
                solution for businesses looking to simplify their Billings, Cash
                / Cheque management, payment reminders, Orders and other
                financial operations.
              </p>
              {isExpanded && (
                <p className="sm:text-lg text-lg font-semibold text-black">
                  <br />{' '}
                  EasyACC is the Best Accounting software for growing
                  Businesses. EasyACC Software is available with special modules
                  for the Textile industry, Garment industry, Engineering units,
                  Job works, Agency business and Travel agents. The software's
                  invoicing & inventory management capabilities provide a simple
                  and efficient way to manage sales & stock, while its annual
                  financial statement feature provides a comprehensive view of a
                  business's financial performance. EasyACC Software demo can be
                  downloaded free of cost.
                  <br />
                  {" "}
                  <br />
                  EasyACC software's account book, bank / cash / JV / voucher
                  and debit note / credit note features provide a complete view
                  of all financial transactions, enabling businesses to
                  effectively manage their financial operations. Additionally,
                  the software's e-way bill generation, GST reports & analysis,
                  purchase management, inventory management, bank management and
                  cash management capabilities provide a comprehensive solution
                  for businesses looking to optimize their financial operations
                  and stay compliant with the latest regulations. To Keep our
                  customers up-dated with current market needs we regularly
                  update & add new features to the software. EasyACC is the best
                  Billing Software for Small Businesses in India.
                </p>
              )}
              <button onClick={toggleExpand} className="mb-8 cursor-pointer sm:block hidden">
                {isExpanded ? "Show Less" : "Show More"}
              </button>
              <div className="flex flex-wrap sm:flex-row mt-5 sm:mt-0">
                <a
                  href="https://www.easyofficesoftware.com/bank_details"
                  target="_blank"
                  rel="noreferrer"
                  className="mb-3 sm:mb-0"
                >
                  <Button label={"Buy Now"} />
                </a>
                <a
                  href="https://www.easyofficesoftware.com/public/catalogue/EasyACC-CATALOGUE.jpg"
                  target="_blank"
                  rel="noreferrer"
                  className="ml-5 mb-3 sm:mb-0"
                >
                  <Button label={"Catalogue"} />
                </a>
                <a
                  href="https://www.easyofficesoftware.com/easyacc"
                  target="_blank"
                  rel="noreferrer"
                  className="sm:ml-5"
                >
                  <Button label={"Learn More"} />
                </a>
              </div>
            </div>
            <div className=" sm:w-1/2 pt-8 px-8 mt-10 sm:mt-0 bg-[#e9f5ff] rounded-2xl shadow-lg">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h1} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Accounting Management
                  </p>
                </div>
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h2} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Billing Management
                  </p>
                </div>
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h3} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Inventory Management
                  </p>
                </div>
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h4} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    GST Returns & Reports
                  </p>
                </div>

                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h6} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    E- Invoice / E-way Bill
                  </p>
                </div>
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h7} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Data Import & Export
                  </p>
                </div>
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h5} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Final Account Statements
                  </p>
                </div>
                <div className="bg-white flex items-center border border-[#02aee6] py-3 px-3 rounded-xl shadow-xl hover:shadow-none duration-150">
                  <img src={h8} alt="gif_Image" className="w-[40px]" />
                  <p className="mb-0 text-black text-lg ml-3 font-semibold">
                    Special Modules for Various Businesses
                  </p>
                </div>
              </div>
              <div className="w-full flex justify-end mt-2 max-w-7xl">
                <a
                  href="https://www.easyofficesoftware.com/easyacc"
                  target="_blank"
                  rel="noreferrer"
                  className="flex items-center justify-end"
                >
                  <p className="mb-0 mr-1 text-black text-lg font-bold">
                    Learn More
                  </p>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    class="bi bi-arrow-right"
                    viewBox="0 0 16 16"
                  >
                    <path
                      fill-rule="evenodd"
                      d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8"
                    />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>

        <div class={`area ${isExpanded ? 'absolute' : 'relative'}`}>
          <ul class="circles">
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
            <li></li>
          </ul>
        </div>
      </div>
    </>
  );
};

export default Hero;
